/**
 * @lodex-pro/web-admin — generic placeholder page (Phase 25 / Task 25.1, DEC-111).
 *
 * Each admin nav section routes here until its real surface is built in a later
 * Phase 25 task. Renders an icon + title + the task description + "Coming soon" so
 * the shell is fully navigable before any content exists.
 */
import * as React from 'react';

export interface PlaceholderPageProps {
  readonly icon: React.ReactNode;
  readonly title: string;
  readonly description: string;
  /** The Phase 25 task that will build this surface, e.g. "Task 25.2". */
  readonly task: string;
}

export function PlaceholderPage({
  icon,
  title,
  description,
  task,
}: PlaceholderPageProps): React.JSX.Element {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        height: '100%',
        padding: '48px 24px',
        color: 'var(--color-text-secondary)',
        fontFamily: 'var(--font-sans, system-ui, sans-serif)',
      }}
    >
      <div
        aria-hidden="true"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '64px',
          height: '64px',
          borderRadius: '12px',
          backgroundColor: 'var(--color-bg-tertiary)',
          color: 'var(--color-link)',
          marginBottom: '16px',
        }}
      >
        {icon}
      </div>
      <h2
        style={{ fontSize: '20px', fontWeight: 600, color: 'var(--color-text-primary)', margin: 0 }}
      >
        {title}
      </h2>
      <p style={{ fontSize: '14px', marginTop: '8px', maxWidth: '420px' }}>{description}</p>
      <span
        style={{
          marginTop: '16px',
          fontSize: '13px',
          fontWeight: 500,
          color: 'var(--color-text-secondary)',
          borderRadius: 'var(--radius-pill)',
          backgroundColor: 'var(--color-bg-secondary)',
          padding: '4px 12px',
        }}
      >
        Coming soon · {task}
      </span>
    </div>
  );
}
